import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'netlify-cms-ui-default';
import { jsx as ___EmotionJSX } from "@emotion/core";

const EmptyMessageContainer = _styled("div", {
  target: "e11npagm0",
  label: "EmptyMessageContainer"
})("height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:", props => props.isPrivate && colors.textFieldBorder, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhTGlicmFyeS9FbXB0eU1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3dDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhTGlicmFyeS9FbXB0eU1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ25ldGxpZnktY21zLXVpLWRlZmF1bHQnO1xuXG5jb25zdCBFbXB0eU1lc3NhZ2VDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY29sb3I6ICR7cHJvcHMgPT4gcHJvcHMuaXNQcml2YXRlICYmIGNvbG9ycy50ZXh0RmllbGRCb3JkZXJ9O1xuYDtcblxuZnVuY3Rpb24gRW1wdHlNZXNzYWdlKHsgY29udGVudCwgaXNQcml2YXRlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8RW1wdHlNZXNzYWdlQ29udGFpbmVyIGlzUHJpdmF0ZT17aXNQcml2YXRlfT5cbiAgICAgIDxoMT57Y29udGVudH08L2gxPlxuICAgIDwvRW1wdHlNZXNzYWdlQ29udGFpbmVyPlxuICApO1xufVxuXG5FbXB0eU1lc3NhZ2UucHJvcFR5cGVzID0ge1xuICBjb250ZW50OiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGlzUHJpdmF0ZTogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBFbXB0eU1lc3NhZ2U7XG4iXX0= */"));

function EmptyMessage({
  content,
  isPrivate
}) {
  return ___EmotionJSX(EmptyMessageContainer, {
    isPrivate: isPrivate
  }, ___EmotionJSX("h1", null, content));
}

EmptyMessage.propTypes = {
  content: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool
};
export default EmptyMessage;